module.exports = __webpack_public_path__ + "static/media/item1.b0552bd5.png";